module.exports = __webpack_public_path__ + "img/img-default.f15d96ff.jpeg";